import { UserRole } from "../../../../shared/enums/userRoles.enum";
import { Company } from "../../../../shared/models/company.model";
import { Organization } from "../../../../shared/models/organization.model";
import { Department } from "../../../../shared/models/department.model";
import { Forklift } from "../../../../shared/models/forklift.model";
import { Device } from "../../../admin-pages/admin-view/models/device.model";
import { Operator } from "../../../admin-pages/admin-view/models/operator.model";
import { ForkliftTag } from "../../../admin-pages/admin-view/models/tag.model";
import { User } from "../../../admin-pages/admin-view/models/user.model";
import { AlarmSets } from "../../../alarms/alarm-sets/models/alarm-sets.model";
import { Alarm } from "../../../alarms/alarm-table/models/alarm.model";
import { Features } from "../../../../shared/models/features.model";
import { WorkingHoursBase } from "@/src/pages/working-hours/models/workingHours.model";
import { GeofencingRegion } from "@/src/pages/geofencing-management/models/geofencing-region.model";

export interface AuthInitialState {
    token: string | null;
    userName: string | null;
    userId: string;
    role: UserRole;
    organizations: Organization[];
    companies: Company[];
    departments: Department[];
    forklifts: Forklift[];
    devices: Device[];
    operators: Operator[];
    tags: ForkliftTag[];
    users: User[];
    alarms: Alarm[];
    alarmSets: AlarmSets[];
    features: Features[];
    userFeatures: Features[];
    regions: GeofencingRegion[];
    models: any[];
    activities: any[];
    workingHours: WorkingHoursBase[];
    enabledAiFeatures: string[];
    user: User | null;
    passwordRecoveryStep: number | null;
    userEmail: string | null;
    organizationLoading: boolean;
    companyLoading: boolean;
    forkliftLoading: boolean;
    usersLoading: boolean;
}

const initialAuthState: AuthInitialState = {
    token: null,
    userName: null,
    userId: "",
    role: UserRole.Admin,
    organizations: [],
    companies: [],
    departments: [],
    forklifts: [],
    operators: [],
    models: [],
    activities: [],
    workingHours: [],
    enabledAiFeatures: [],
    user: null,
    passwordRecoveryStep: null,
    userEmail: null,
    devices: [],
    tags: [],
    users: [],
    alarms: [],
    alarmSets: [],
    features: [],
    userFeatures: [],
    regions: [],
    organizationLoading: false,
    companyLoading: false,
    forkliftLoading: false,
    usersLoading: false,
}

export default initialAuthState